export default "__VITE_ASSET__4a6bc1fa__"